import { Component, OnInit } from "@angular/core";
//kopieer van hier
import { NgIf } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { Observable, of } from "rxjs";
import { PageComponent } from "../../../_shared/components/layout/page/page.component";
import { EditPage } from "../../../_shared/components/layout/pages/edit-page";
import { RightNavComponent } from "../../../_shared/components/layout/right-nav/right-nav.component";
import { DummyData, DummyFormModel } from "../../../_shared/form-model/dummy-form-group";
import { ButtonComponent } from "../../../_shared/form/components/button/button.component";
import { CardWrapperComponent } from "../../../_shared/form/components/card-wrapper/card-wrapper.component";
import { HorizontalTextInputComponent } from "../../../_shared/form/components/horizontal-text-input/horizontal-text-input.component";
import { MultiSelectComponent } from "../../../_shared/form/components/multi-select/multi-select.component";
import { RadioGroupComponent } from "../../../_shared/form/components/radio-group/radio-group.component";
import { RadioComponent } from "../../../_shared/form/components/radio/radio.component";
import { RichTextComponent } from "../../../_shared/form/components/rich-text/rich-text.component";
import { SelectComponent } from "../../../_shared/form/components/select/select.component";
import { SelectOption } from "../../../_shared/models/option";
//tot hier

@Component({
  selector: "app-dummy-page",
  templateUrl: "./dummy-page.component.html",
  styleUrls: ["./dummy-page.component.scss"],
  standalone: true,
  imports: [
    PageComponent,
    NgIf,
    ReactiveFormsModule,
    CardWrapperComponent,
    SelectComponent,
    HorizontalTextInputComponent,
    MultiSelectComponent,
    RadioGroupComponent,
    RadioComponent,
    RichTextComponent,
    ButtonComponent,
    RightNavComponent,
  ],
})
// kopieer van hier
export class DummyPageComponent extends EditPage implements OnInit {
  formModel: DummyFormModel;

  options: Observable<SelectOption[]> = of([
    { id: "1", name: "Keuze 1" },
    { id: "2", name: "Keuze 2" },
    { id: "3", name: "Keuze 3" },
  ]);
  selectedIds: string[] = [];

  constructor(protected override route: ActivatedRoute) {
    super(route);
    this.formModel = new DummyFormModel(new DummyData());
  }

  ngOnInit(): void {
    this.init();
  }
}
// tot hier
